export enum EcomRoutesMapping {
  LOGOUT = '/logout',
  COURSES = '/minha-conta/meus-cursos',
  PROFILE = '/minha-conta/meus-dados',
  ORDERS = '/minha-conta/meus-pedidos',
  CERTIFICATE = '/minha-conta/certificados'
}